<div
  class="vk-panel"
  *ngIf="target"
  #panel
  (mousedown)="preventBlur($event)"
>
  <div class="vk-header">
    <span class="vk-label">{{ target.label }}</span>
    <button
      type="button"
      class="vk-done"
      (click)="close()"
    >
      Pronto
    </button>
  </div>
  <!--
    O simple-keyboard reescreve o className do elemento em que monta, entao a
    classe de layout fica no WRAPPER: no proprio host ela seria apagada e o
    teclado numerico perderia a largura compacta. O host precisa de uma classe
    propria: a biblioteca a usa como identificador e recusa um elemento sem
    class (KEYBOARD_DOM_CLASS_ERROR).
  -->
  <div
    class="vk-keys"
    [class.vk-keys--numeric]="target.layout === 'numeric'"
  >
    <div
      class="vk-keyboard-host"
      #keyboardHost
    ></div>
  </div>
</div>
